class StudentGroups {

    studentInternationalGroupElements: NodeListOf<HTMLElement>;
    studentDomesticGroupElements: NodeListOf<HTMLElement>;
    currentGroup: String = "domestic";

    constructor() {
        // do something
        this.init();
    }

    init() {
        // do more
        this.studentInternationalGroupElements = document.querySelectorAll("[data-student-group=\"international\"]");
        this.studentDomesticGroupElements = document.querySelectorAll("[data-student-group=\"domestic\"]");
    }

    toggleGroup() {
        if (this.currentGroup == "domestic") {
            this.currentGroup = "international";
        } else if (this.currentGroup == "international") {
            this.currentGroup = "domestic";
        }
    }

    update() {
        let self = this;
        // var studentInternationalGroupElements = document.querySelectorAll("[data-student-group=\"international\"]");
        // var studentDomesticGroupElements = document.querySelectorAll("[data-student-group=\"domestic\"]");
        let intakeTitle = document.querySelectorAll(".d-none-international");
        this.studentInternationalGroupElements.forEach(function(element: HTMLElement){
            let displayValue = element.dataset.display? element.dataset.display : "inline-block";
            if (self.currentGroup == "international") {
                element.dataset.toggled = "1";
                element.style.display = displayValue;
                if(intakeTitle){
                    intakeTitle.forEach(function(elemTitle: HTMLElement){ 
                        elemTitle.style.display = "none";
                    });
                }
            } else {
                element.dataset.toggled = "0";
                element.style.display = "none";
            }
        });

        this.studentDomesticGroupElements.forEach(function(element: HTMLElement){
            let displayValue = element.dataset.display? element.dataset.display : "inline-block";
            if (self.currentGroup == "domestic") {
                element.dataset.toggled = "1";
                element.style.display = displayValue;
                if(intakeTitle){
                    intakeTitle.forEach(function(elemTitle: HTMLElement){
                        elemTitle.style.display = displayValue;
                    });
                }
            } else {
                element.dataset.toggled = "0";
                element.style.display = "none";
            }
        });
    }
}

export default StudentGroups;